import { CountryCode } from "custom-types/Finder";
import { RetailType } from "custom-types/Store";

import Views from "./finderConfig";

type StaticFinderConfig = {
  countryCode: CountryCode;
  farAwayThreshold: number;
  finderRoute: string;
  storeRoute: string;
  title: string;
  type: RetailType;
};

export default (countryCode: "CA" | "US", retailType: RetailType) => {
  const {
    countryCode: _country,
    type: _type,
    ...rest
  } = Views.find(
    (view) => view.countryCode === countryCode && view.type === retailType
  ) as StaticFinderConfig;

  return rest;
};
